import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";

import {
  IAPI_STA003_Request,
  IAPI_STA003_Response,
} from "../../../type/apiType";

import {
  IAPI_APP110_Request,
  IAPI_APP110_Response,
} from "../../../type/apiType";

import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

// 退職者情報詳細参照API
// API仕様書_法人職員
const httpAPI_STA003 = async (
  param: IAPI_STA003_Request
): Promise<IAPI_STA003_Response> => {
  let res = await http.post(ApiUrl.API_STA003, {
    ...param,
  });

  return res.data;
};

// 退職理由更新API
// API仕様書_要処理対応
const httpAPI_APP110 = async (
  param: IAPI_APP110_Request
): Promise<IAPI_APP110_Response> => {
  let res = await http.post(ApiUrl.API_APP110, {
    ...param,
  });

  return res.data;
};

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_STA003, httpAPI_APP110, httpAPI_APP016 };
